module.exports = __webpack_public_path__ + "static/img/check-circle.e3125eda.svg";